var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "holdRuleGroupDelete"
  }, [_c('b-card', {
    staticClass: "mb-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', [_vm._v("Definitief verwijderen")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-text', [_vm._v(" Weet u zeker dat u de volledige groep wil verwijderen? Deze actie kan niet ongedaan worden gemaakt. Wellicht wil u de groep eerst op inactief zetten. ")]), _c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.cancelDelete
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" Annuleren ")]), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v(" Definitief verwijderen ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }